import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import {
  getPatientByIdApiRoute,
  editPatientProfileApiRoute
} from "../../apiRoutes";

import { getFormattedMonthDateV3 } from "../../utils/dateTimeHelper";

import Loader from "../../components/loader";
import Label from "./../../components/label";
import Button from "./../../components/button";
import ICInput from "../../components/form/input";
import CustomModal from "../../components/modal";
import PropTypes from "prop-types";
import PreviouslyPrescribed from "../PreviouslyPrescribed";

const PatientDetails = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [patientDetails, setPatientDetails] = useState(null);

  const [cmText, setCmText] = useState("");
  const [hcText, setHcText] = useState("");
  const [kaText, setKaText] = useState("");
  const [cmErrText, setCmErrText] = useState("");
  const [hcErrText, setHcErrText] = useState("");
  const [kaErrText, setKaErrText] = useState("");

  const [cmInputErr, setCmInputErr] = useState(false);
  const [hcInputErr, setHcInputErr] = useState(false);
  const [kaInputErr, setKaInputErr] = useState(false);

  const [editCurrentMedication, setEditCurrentMedication] = useState(false);
  const [editHealthCondition, setEditHealthCondition] = useState(false);
  const [editKnownAllergies, setEditKnownAllergies] = useState(false);

  // get patient data
  const getPatientData = () => {
    setIsProcessing(true);

    let params = {
      patientId: props.patientId
    };
    setApiCallParams({
      reqType: "GET",
      reqURL: getPatientByIdApiRoute,
      params: params,
      successCallback: async res => {
        setIsProcessing(false);
        setPatientDetails(res.data.data);

        if (
          res.data.data.currentMedication !== undefined &&
          res.data.data.currentMedication !== null
        ) {
          setCmText(res.data.data.currentMedication.info);
        }

        if (
          res.data.data.healthConditions !== undefined &&
          res.data.data.healthConditions !== null
        ) {
          setHcText(res.data.data.healthConditions.info);
        } else {
          setHcText(res.data.data.medicalInfo ? res.data.data.medicalInfo : "");
        }

        if (
          res.data.data.knownAllergies !== undefined &&
          res.data.data.knownAllergies !== null
        ) {
          setKaText(res.data.data.knownAllergies.info);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update medical information
  const updateMedicalInformation = (key, val) => {
    setIsProcessing(true);
    setEditCurrentMedication(false);
    setEditHealthCondition(false);
    setEditKnownAllergies(false);

    let formData = new FormData();

    if (patientDetails !== null) {
      formData.append("streetNumber", patientDetails.address.streetNumber);
      formData.append("streetName", patientDetails.address.streetName);
      formData.append("suburb", patientDetails.address.suburb);
      formData.append("state", patientDetails.address.state);
      formData.append("postCode", patientDetails.address.postCode);
      formData.append("unitNumber", patientDetails.address.unitNumber);
    }

    formData.append("isFile", "false");
    formData.append(key, val);

    let pid = "";

    if (patientDetails !== null) {
      pid = patientDetails._id;
    }

    setApiCallParams({
      reqType: "PUT",
      reqURL: editPatientProfileApiRoute + "/" + pid,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        setModalText("Medical Information Updated Successfully");
        setShowTextModal(true);
        getPatientData();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    if (props.auth.urlParams !== null) {
      getPatientData();
    }
  }, [props.auth.urlParams]);

  const handleCmInputChange = e => {
    if (e.target.value.length > 2500) {
      setCmInputErr(true);
      setCmErrText("Maximum 2500 characters are allowed");
    } else {
      setCmText(e.target.value);
      setCmInputErr(false);
      setCmErrText("");
    }
  };

  const handleHcInputChange = e => {
    if (e.target.value.length > 2500) {
      setHcInputErr(true);
      setHcErrText("Maximum 2500 characters are allowed");
    } else {
      setHcText(e.target.value);
      setHcInputErr(false);
      setHcErrText("");
    }
  };

  const handleKaInputChange = e => {
    if (e.target.value.length > 2500) {
      setKaInputErr(true);
      setKaErrText("Maximum 2500 characters are allowed");
    } else {
      setKaText(e.target.value);
      setKaInputErr(false);
      setKaErrText("");
    }
  };

  const cancelMedicationEdit = () => {
    setEditCurrentMedication(false);
    setCmInputErr(false);
    setCmErrText("");
    if (
      patientDetails !== null &&
      patientDetails.currentMedication !== undefined &&
      patientDetails.currentMedication !== null
    ) {
      setCmText(patientDetails.currentMedication.info);
    } else {
      setCmText("");
    }
  };

  const cancelHealthConditionEdit = () => {
    setEditHealthCondition(false);
    setHcInputErr(false);
    setHcErrText("");
    if (
      patientDetails !== null &&
      patientDetails.healthConditions !== undefined &&
      patientDetails.healthConditions !== null
    ) {
      setHcText(patientDetails.healthConditions.info);
    } else {
      setHcText(patientDetails.medicalInfo ? patientDetails.medicalInfo : "");
    }
  };

  const cancelKnownAllergiesEdit = () => {
    setEditKnownAllergies(false);
    setKaInputErr(false);
    setKaErrText("");
    if (
      patientDetails !== null &&
      patientDetails.knownAllergies !== undefined &&
      patientDetails.knownAllergies !== null
    ) {
      setKaText(patientDetails.knownAllergies.info);
    } else {
      setKaText("");
    }
  };

  return (
    <div className={props.className || "col-sm-12 medicalInfo"}>
      <CustomModal
        useOneButton={true}
        cancelText="Okay"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={`<p className="text-center mb-0">${modalText}</p>`}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div>
          <div className="border-bottom">
            <Label title="Current Medications" className="font-weight-bold" />
            <Button
              title="Edit"
              className={
                "text-right float-right m-0 link " +
                (editCurrentMedication ? "d-none" : "d-block")
              }
              clickEvent={() => {
                setEditCurrentMedication(true);
              }}
            />
          </div>
          <ICInput
            value={cmText}
            name="cmText"
            className={
              "text-area mt-2 " + (editCurrentMedication ? "" : "d-none")
            }
            label=""
            multiline
            rows="5"
            placeholder="Add text here..."
            error={cmInputErr}
            helperText={cmErrText}
            onChange={handleCmInputChange}
          />
          <div className={editCurrentMedication ? "d-none" : "d-block"}>
            {patientDetails !== null && !patientDetails.currentMedication && (
              <p className="insta-label small pd-2  mb-0">
                No Current Medications added
              </p>
            )}
            {patientDetails !== null &&
              patientDetails.currentMedication !== undefined &&
              patientDetails.currentMedication !== null && (
                <Fragment>
                  <p
                    className="insta-label small pd-2 mb-0"
                    dangerouslySetInnerHTML={{
                      __html:
                        patientDetails.currentMedication.info.length > 0
                          ? patientDetails.currentMedication.info.replace(
                              /\r?\n/g,
                              "<br/>"
                            )
                          : ""
                    }}
                  ></p>
                  <p className="insta-label small pd-2 mb-0">
                    {patientDetails.currentMedication.info.length === 0 &&
                      "No Current Medications added"}
                  </p>
                  {patientDetails.currentMedication.doctorId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.currentMedication.updatedAt
                      )}
                      &nbsp;by Dr.&nbsp;
                      {patientDetails.currentMedication.doctorId.firstName +
                        " " +
                        patientDetails.currentMedication.doctorId.lastName}
                      &nbsp;|&nbsp;UIN:&nbsp;
                      {patientDetails.currentMedication.doctorId.doctorId}
                    </p>
                  )}
                  {patientDetails.currentMedication.adminId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.currentMedication.updatedAt
                      )}
                      &nbsp;by&nbsp;
                      {patientDetails.currentMedication.adminId.firstName}&nbsp;
                      {patientDetails.currentMedication.adminId.lastName}
                      &nbsp;|&nbsp;
                      {patientDetails.currentMedication.adminId.userType.includes(
                        "ADMIN"
                      )
                        ? "Admin Staff"
                        : "Support Staff"}
                    </p>
                  )}
                </Fragment>
              )}
          </div>
          <Button
            title="Save"
            className={
              "float-left mt-2 mr-2 small gray " +
              (editCurrentMedication ? "d-block" : "d-none")
            }
            clickEvent={() => {
              updateMedicalInformation("currentMedication", cmText);
            }}
          />
          <Button
            title="Cancel"
            className={
              "mt-2 small gray " +
              (editCurrentMedication ? "d-block" : "d-none")
            }
            clickEvent={cancelMedicationEdit}
          />
        </div>

        <div className="mt-4">
          <div className="border-bottom">
            <Label title="Health Conditions" className="font-weight-bold" />
            <Button
              title="Edit"
              className={
                "text-right float-right m-0 link " +
                (editHealthCondition ? "d-none" : "d-block")
              }
              clickEvent={() => {
                setEditHealthCondition(true);
              }}
            />
          </div>
          <ICInput
            name="hcText"
            value={hcText}
            className={
              "text-area mt-2 " + (editHealthCondition ? "" : "d-none")
            }
            label=""
            multiline
            rows="5"
            placeholder="Add text here..."
            onChange={handleHcInputChange}
            error={hcInputErr}
            helperText={hcErrText}
          />
          <div className={editHealthCondition ? "d-none" : "d-block"}>
            {/* {patientDetails !== null &&
              !patientDetails.healthConditions && (
                <p className="insta-label small pd-2 mb-0">
                  No Health Conditions added
                </p>
              )} */}
              {
                patientDetails !== null && !patientDetails.healthConditions && (patientDetails.medicalInfo && patientDetails.medicalInfo !== "") && (
                <p
                  className="insta-label small pd-2 mb-0"
                  dangerouslySetInnerHTML={{
                    __html:
                      patientDetails.medicalInfo.length > 0
                        ? patientDetails.medicalInfo.replace(
                            /\r?\n/g,
                            "<br/>"
                          )
                        : ""
                  }}
                ></p>
                )
              }
              {patientDetails !== null && !patientDetails.healthConditions && (patientDetails.medicalInfo === "" || patientDetails.medicalInfo === undefined || patientDetails.medicalInfo === null) && (
                <p className="insta-label small pd-2 mb-0">
                      No Health Conditions added
                  </p> )}
              {patientDetails !== null && !patientDetails.healthConditions && (patientDetails.medicalInfo && patientDetails.medicalInfo !== "") && (
                    <p className="lighter-text mt-2 xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.updatedAt
                      )}
                      &nbsp;by Patient:&nbsp;
                      {patientDetails.firstName +
                        " " +
                        patientDetails.lastName}
                      &nbsp;|&nbsp;UIN:&nbsp;
                      {patientDetails.patientId}
                    </p>
                  )}
            {patientDetails !== null &&
              patientDetails.healthConditions !== undefined &&
              patientDetails.healthConditions !== null && (
                <Fragment>
                  <p
                    className="insta-label small pd-2 mb-0"
                    dangerouslySetInnerHTML={{
                      __html:
                        patientDetails.healthConditions.info.length > 0
                          ? patientDetails.healthConditions.info.replace(
                              /\r?\n/g,
                              "<br/>"
                            )
                          : ""
                    }}
                  ></p>
                  { <p className="insta-label small pd-2 mb-0">
                    {patientDetails.healthConditions.info.length === 0 &&
                      "No Health Conditions added"}
                  </p> }
                  {patientDetails.healthConditions.doctorId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.healthConditions.updatedAt
                      )}
                      &nbsp;by Dr.&nbsp;
                      {patientDetails.healthConditions.doctorId.firstName +
                        " " +
                        patientDetails.healthConditions.doctorId.lastName}
                      &nbsp;|&nbsp;UIN:&nbsp;
                      {patientDetails.healthConditions.doctorId.doctorId}
                    </p>
                  )}
                  {patientDetails.healthConditions.adminId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.healthConditions.updatedAt
                      )}
                      &nbsp;by&nbsp;
                      {patientDetails.healthConditions.adminId.firstName}&nbsp;
                      {patientDetails.healthConditions.adminId.lastName}
                      &nbsp;|&nbsp;
                      {patientDetails.healthConditions.adminId.userType.includes(
                        "ADMIN"
                      )
                        ? "Admin Staff"
                        : "Support Staff"}
                    </p>
                  )}
                </Fragment>
              )}
            {/* {patientDetails !== null &&
              (patientDetails.healthConditions === undefined ||
                patientDetails.healthConditions === null) &&
              patientDetails.medicalInfo !== undefined &&
              patientDetails.medicalInfo !== null && (
                <Fragment>
                  <p
                    className="insta-label small pd-2 mb-0"
                    dangerouslySetInnerHTML={{
                      __html:
                        patientDetails.medicalInfo.length > 0
                          ? patientDetails.medicalInfo.replace(
                              /\r?\n/g,
                              "<br/>"
                            )
                          : ""
                    }}
                  ></p>
                  <p className="insta-label small pd-2 mb-0">
                    {patientDetails.medicalInfo.length === 0 &&
                      "No Health Conditions added"}
                  </p>
                  <p className="lighter-text xs-small pt-0 pd-2 w-100">
                    Last Updated on&nbsp;
                    {getFormattedMonthDateV3(patientDetails.updatedAt)}
                    &nbsp;by&nbsp;
                    {patientDetails.firstName + " " + patientDetails.lastName}
                    &nbsp;|&nbsp;UIN:&nbsp;
                    {patientDetails.patientId}
                  </p>
                </Fragment>
              )} */}
          </div>
          <Button
            title="Save"
            className={
              "float-left mt-2 mr-2 small gray " +
              (editHealthCondition ? "d-block" : "d-none")
            }
            clickEvent={() => {
              updateMedicalInformation("healthConditions", hcText);
            }}
          />
          <Button
            title="Cancel"
            className={
              "mt-2 small gray " + (editHealthCondition ? "d-block" : "d-none")
            }
            clickEvent={cancelHealthConditionEdit}
          />
        </div>

        <div className="mt-4">
          <div className="border-bottom">
            <Label title="Known Allergies" className="font-weight-bold" />
            <Button
              title="Edit"
              className={
                "text-right float-right m-0 link " +
                (editKnownAllergies ? "d-none" : "d-block")
              }
              clickEvent={() => {
                setEditKnownAllergies(true);
              }}
            />
          </div>
          <ICInput
            name="kaText"
            value={kaText}
            className={"text-area mt-2 " + (editKnownAllergies ? "" : "d-none")}
            label=""
            multiline
            rows="5"
            placeholder="Add text here..."
            onChange={handleKaInputChange}
            error={kaInputErr}
            helperText={kaErrText}
          />
          <div className={editKnownAllergies ? "d-none" : "d-block"}>
            {patientDetails !== null && !patientDetails.knownAllergies && (
              <p className="insta-label small pd-2 mb-0">
                No Known Allergies added
              </p>
            )}
            {patientDetails !== null &&
              patientDetails.knownAllergies !== undefined &&
              patientDetails.knownAllergies !== null && (
                <Fragment>
                  <p
                    className="insta-label small pd-2 mb-0"
                    dangerouslySetInnerHTML={{
                      __html:
                        patientDetails.knownAllergies.info.length > 0
                          ? patientDetails.knownAllergies.info.replace(
                              /\r?\n/g,
                              "<br/>"
                            )
                          : ""
                    }}
                  ></p>
                  <p className="insta-label small pd-2 mb-0">
                    {patientDetails.knownAllergies.info.length === 0 &&
                      "No Known Allergies added"}
                  </p>
                  {patientDetails.knownAllergies.doctorId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.knownAllergies.updatedAt
                      )}
                      &nbsp;by Dr.&nbsp;
                      {patientDetails.knownAllergies.doctorId.firstName +
                        " " +
                        patientDetails.knownAllergies.doctorId.lastName}
                      &nbsp;|&nbsp;UIN:&nbsp;
                      {patientDetails.knownAllergies.doctorId.doctorId}
                    </p>
                  )}
                  {patientDetails.knownAllergies.adminId && (
                    <p className="lighter-text xs-small pt-0 pd-2 w-100">
                      Last Updated on&nbsp;
                      {getFormattedMonthDateV3(
                        patientDetails.knownAllergies.updatedAt
                      )}
                      &nbsp;by&nbsp;
                      {patientDetails.knownAllergies.adminId.firstName}&nbsp;
                      {patientDetails.knownAllergies.adminId.lastName}
                      &nbsp;|&nbsp;
                      {patientDetails.knownAllergies.adminId.userType.includes(
                        "ADMIN"
                      )
                        ? "Admin Staff"
                        : "Support Staff"}
                    </p>
                  )}
                </Fragment>
              )}
          </div>
          <Button
            title="Save"
            className={
              "float-left mt-2 mr-2 small gray " +
              (editKnownAllergies ? "d-block" : "d-none")
            }
            clickEvent={() => {
              updateMedicalInformation("knownAllergies", kaText);
            }}
          />
          <Button
            title="Cancel"
            className={
              "mt-2 small gray " + (editKnownAllergies ? "d-block" : "d-none")
            }
            clickEvent={cancelKnownAllergiesEdit}
          />
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

PatientDetails.propTypes = {
  patientId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(PatientDetails);
